import React, { useState, useRef } from 'react';
import {
  Card, Form, Col, Button,
} from 'react-bootstrap';
import DownloadLink from '../../../../components/common/DownloadLink';
import { useOutsideClick } from '../../../../hooks/useOutsideClick';

export default function ButtonsCard({
  can, projId, originId, onEdit, onEditCurrent, onEditMilestones, onSendPortf, onSendHeadSP, onReturnForRevisionHead, onReturnForRevisionPortf, onExpertsApprove, onApproveFinal, onDelete, onMoveProject, parentProjectType,
}) {
  const [show, setShow] = useState(false);
  const [animationShow, setAnimationShow] = useState(false);
  const actionsRef = useRef();
  const buttonRef = useRef();

  const handleActionClick = (callback) => {
    handleShow(false);
    callback();
  };

  const handleShow = (show) => {
    if (show) {
      setShow(true);
      setTimeout(() => setAnimationShow(true), 50);
    } else {
      setAnimationShow(false);
      setTimeout(() => setShow(false), 200);
    }
  };

  useOutsideClick([actionsRef, buttonRef], () => handleShow(false));

  return (
    <div className="d-flex flex-column gap-2 align-items-end" style={{ position: 'fixed', right: 50, bottom: 50 }}>
      <Card
        style={{
          transform: animationShow ? 'scale(1)' : 'scale(0)',
          transition: 'transform 0.2s ease-in',
          display: show ? 'block' : 'none',
        }}
        ref={actionsRef}
      >
        <Card.Body>
          <Form.Group as={Col}>
            { can.Edit && <Button className="me-2" variant="outline-secondary" onClick={() => onEdit()}>Редактировать</Button> }
            { can.EditCurrent && <Button className="me-2" variant="outline-secondary" onClick={onEditCurrent}>Внести изменения в текущую версию</Button> }
            { can.MoveProject && <Button className="me-2" variant="outline-success" onClick={() => handleActionClick(onMoveProject)}>Перенести проект</Button> }
            { can.EditCurrentMilestones && <Button className="me-2" variant="outline-secondary" onClick={onEditMilestones}>Добавить вехи в паспорт</Button> }
            { can.SendToPortf && <Button className="me-2" variant="outline-warning" onClick={onSendPortf}>Отправить руководителю портфеля</Button> }
            { can.SendToHead && (
              <Button className="me-2" variant="outline-warning" onClick={onSendHeadSP}>
                Отправить руководителю
                {' '}
                {parentProjectType === 'strategy' ? 'СП' : 'политики'}
              </Button>
            ) }
            { can.HeadReturn && <Button className="me-2" variant="outline-danger" onClick={onReturnForRevisionHead}>Вернуть на доработку</Button>}
            { can.PortfReturn && <Button className="me-2" variant="outline-danger" onClick={onReturnForRevisionPortf}>Вернуть на доработку</Button>}
            { can.ExpertsApprove && <Button className="me-2" variant="outline-warning" onClick={onExpertsApprove}>Одобрить</Button>}
            { can.ApproveFinal && <Button className="me-2" variant="success" onClick={onApproveFinal}>Подписанный скан ЦП</Button> }
            { projId && parseInt(projId) === originId && can.Delete && <Button className="me-2" variant="outline-danger" onClick={onDelete}>Удалить</Button>}
            <DownloadLink variant="outline-secondary" url={`/projs/${projId}/print2`}>Сформировать PDF</DownloadLink>
          </Form.Group>
        </Card.Body>
      </Card>
      <Button variant="danger" onClick={() => handleShow(!show)} ref={buttonRef}>Действия</Button>
    </div>

  );
}
